module.exports = __webpack_public_path__ + "media/images/pic/program-rozwoju-obszarow-wiejskich-070e8e3cb4330732e5332a0651cc0f27.jpg";